export default "__VITE_ASSET__wK_eJOai__"